import React, { useState, useEffect, useRef } from "react";
import "./styles.css";
/**
 * @function UICheckbox 
 * @param {STRING} checked - Allows us to set if the checkbox is selected or not ("yes" or "no"). 
 * @param {STRING} label - Allows us to set the text of the span to the right of the checkbox.
 * @param {STRING} value - Allows us to set the value of the checkbox.
 * @param {FUNCTION} onClick - Allows us to set an event handler for the checkbox when clicked.  
 * @returns {React.Component}
 * @example
 * <UICheckbox checked="no" value="0" label="Some label" onClick={()=> alert("Hello")}/>
 */
export default function UICheckbox(props) {
  const dataPoint = props.dataPoint ?? "";
  const label = props.label ?? "[Checkbox label]";
  // Initalize state for the checkbox
  const [ state, setState ] = useState(props.value ?? false);
  const checkbox = useRef();
  const disabledClass = props.disabled ? "disabled" : "";
  // onChange function to update state and run the prop.onChange
  // function if a function was passed
  const onChange = evt => {
    const value = checkbox.current.checked;
    setState(value);

    if(props.onChange instanceof Function) {
      props.onChange(value);
    }
  };
  // Update the state whenever the 'props.value' was updated
  useEffect(() => setState(props.value), [ props.value ]);

  return (
    <label className={ `ui-checkbox flex-container flex-horizontal ${ disabledClass }` } data-point={ dataPoint }>
      <div className="set-width">
        <input type="checkbox"  onChange={ onChange } checked={ state } ref={ checkbox } disabled={ props.disabled } />
        <span className="ui-checkbox-indicator" data-point={ dataPoint+"_checkbox" }></span>
      </div>
      <span className="ui-checkbox-label flex-width" data-point={ dataPoint+"_label" }>{ label }</span>
    </label>
  );
}